import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OpcionesService, PanelItemOpcionesVM } from '../../infrastructure/services/opciones.service';
import { AlertService, GrowlType } from '../../infrastructure/services/alert.service';
import { SxContextService } from '../../infrastructure/services/sxContext.service';

@Component({
  templateUrl: 'listado.opciones.component.html'
})
export class ListadoOpcionesComponent implements OnInit {
  codSistema: string;
  codNegocio: string;
  codProducto: string;
  codorganizacion:string;
  opciones: PanelItemOpcionesVM[];
  listadoFiltrado: any;
  buscarListado: String = '';
  preguntarSiDeseaBorrar = [];
  constructor(private aRoute: ActivatedRoute,
    private alertService: AlertService,
    private router: Router,
    private opcionesService: OpcionesService,
    public sxContextService: SxContextService) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProducto = params['codproducto'];
      this.codorganizacion=params['codorganizacion'];
      this.opcionesService
        .getByProducto(this.codSistema, this.codNegocio, this.codProducto)
        .then(opciones => {
          this.opciones = opciones;
          this.filtrarListado();
        });
    });
  }
  filtrarListado() {
    this.listadoFiltrado = this.opciones.filter(item =>
      item.optionNumber.toString().toUpperCase().indexOf(this.buscarListado.toUpperCase()) !== -1
      || item.codPlan.toString().toUpperCase().indexOf(this.buscarListado.toUpperCase()) !== -1
      || item.description.toString().toUpperCase().indexOf(this.buscarListado.toUpperCase()) !== -1
      || item.codProvider.toString().toUpperCase().indexOf(this.buscarListado.toUpperCase()) !== -1
    );
  }
  agregar() {
    this.router.navigate([`/soc/organizations/${this.codorganizacion}/subscriptions/${this.codSistema}/BuscadorProducto/${this.codNegocio}/${this.codProducto}`]);
  }

  edit(commercialProductId: number) {
    this.router.navigate(['editar', commercialProductId], { relativeTo: this.aRoute });
  }

  eliminar(idOpcion) {
    this.opcionesService.eliminar(idOpcion)
      .then(idOpcionEliminada => {
        const index = this.opciones.findIndex(opciones => opciones.commercialProductId === idOpcionEliminada);
        this.alertService.showGrowl({
          body: 'COMMERCIAL_PRODUCT_REMOVED',
          type: GrowlType.SUCCESS
        },
          { commercialProduct: idOpcionEliminada });

        this.opciones = this.opciones.filter(x => x.commercialProductId !== idOpcionEliminada);
        this.filtrarListado();
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/opciones/listado.opciones.component.ts